import { render, staticRenderFns } from "./CVTypeBase.vue?vue&type=template&id=fba118b0"
import script from "./CVTypeBase.vue?vue&type=script&lang=js"
export * from "./CVTypeBase.vue?vue&type=script&lang=js"
import style0 from "./CVTypeBase.vue?vue&type=style&index=0&id=fba118b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports